import React from 'react';

function Logistics() {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_320)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M23 53V28H30C30.2652 28 30.5196 27.8947 30.7071 27.7071C30.8947 27.5196 31 27.2652 31 27V20H50C50.2652 20 50.5196 20.1054 50.7071 20.2929C50.8946 20.4804 51 20.7348 51 21V34H53V21C53 20.2044 52.6839 19.4413 52.1213 18.8787C51.5587 18.3161 50.7957 18 50 18H30C29.8684 17.9993 29.7379 18.0245 29.6161 18.0742C29.4943 18.124 29.3835 18.1973 29.29 18.29L21.29 26.29C21.1973 26.3835 21.124 26.4943 21.0742 26.6161C21.0245 26.7379 20.9993 26.8684 21 27V53C21 53.7957 21.3161 54.5587 21.8787 55.1213C22.4413 55.6839 23.2044 56 24 56H37.94V54H24C23.7348 54 23.4804 53.8946 23.2929 53.7071C23.1054 53.5196 23 53.2652 23 53ZM24.41 26L29 21.41V26H24.41ZM27 31H38V33H27V31ZM33 26H38V28H33V26ZM27 36H38V38H27V36ZM27 41H38V43H27V41ZM27 46H38V48H27V46ZM56 36H44C43.2044 36 42.4413 36.3161 41.8787 36.8787C41.3161 37.4413 41 38.2044 41 39V59C41 59.7957 41.3161 60.5587 41.8787 61.1213C42.4413 61.6839 43.2044 62 44 62H56C56.7957 62 57.5587 61.6839 58.1213 61.1213C58.6839 60.5587 59 59.7957 59 59V39C59 38.2044 58.6839 37.4413 58.1213 36.8787C57.5587 36.3161 56.7957 36 56 36ZM57 59C57 59.2652 56.8946 59.5196 56.7071 59.7071C56.5196 59.8946 56.2652 60 56 60H44C43.7348 60 43.4804 59.8946 43.2929 59.7071C43.1054 59.5196 43 59.2652 43 59V39C43 38.7348 43.1054 38.4804 43.2929 38.2929C43.4804 38.1054 43.7348 38 44 38H56C56.2652 38 56.5196 38.1054 56.7071 38.2929C56.8946 38.4804 57 38.7348 57 39V59ZM54 40H46C45.7348 40 45.4804 40.1054 45.2929 40.2929C45.1054 40.4804 45 40.7348 45 41V45C45 45.2652 45.1054 45.5196 45.2929 45.7071C45.4804 45.8947 45.7348 46 46 46H54C54.2652 46 54.5196 45.8947 54.7071 45.7071C54.8946 45.5196 55 45.2652 55 45V41C55 40.7348 54.8946 40.4804 54.7071 40.2929C54.5196 40.1054 54.2652 40 54 40ZM53 44H47V42H53V44ZM45 48H49V50H45V48ZM51 48H55V50H51V48ZM45 52H49V54H45V52ZM51 52H55V54H51V52ZM45 56H49V58H45V56ZM51 56H55V58H51V56ZM43 26V27H46C46.2652 27 46.5196 27.1054 46.7071 27.2929C46.8946 27.4804 47 27.7348 47 28V31C47 31.2652 46.8946 31.5196 46.7071 31.7071C46.5196 31.8947 46.2652 32 46 32H45V33H43V32H41V30H45V29H42C41.7348 29 41.4804 28.8947 41.2929 28.7071C41.1054 28.5196 41 28.2652 41 28V25C41 24.7348 41.1054 24.4804 41.2929 24.2929C41.4804 24.1054 41.7348 24 42 24H43V23H45V24H47V26H43Z'
            fill='#FEFEFE'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_115_320'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_320'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Logistics;
